import React, { PureComponent } from 'react'
import { MultiSelect } from 'primereact/multiselect';
import Button from 'UI/Button';
import { sortAndFilterEnabelemetWaves } from 'utils/Utils'

export default class VendorUploadFilesModalContainer extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            rowData: props.rowData,
            wave: [],
            wavesSelected: null,
            filteredData: []
        }
    }

    componentDidMount() {
        let dummy = this.props.waves;
        // Extract unique values
        let unique = [...new Set(dummy)];

        // Split into numeric and non-numeric
        const numeric = [];
        const nonNumeric = [];

        unique.forEach(item => {
            const num = Number(item);
            if (!isNaN(num) && item !== null && item !== '') {
                numeric.push({ label: item, value: item, numericValue: num });
            } else {
                nonNumeric.push({ label: item, value: item });
            }
        });

        // Sort numeric ascending
        numeric.sort((a, b) => a.numericValue - b.numericValue);
        // Sort non-numeric alphabetically (case-insensitive)
        nonNumeric.sort((a, b) => String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' }));

        // Combine: numeric first, then non-numeric
        const tempWaveObj = [...numeric, ...nonNumeric];

        this.setState({ wave: tempWaveObj });
    }

    handleWaveChange(data) {
        let waves = data.value;
        let rowData = this.state.rowData;
    
        let filteredData = rowData.filter((item, index) => {
            // Always keep the first 5 rows
            if (index < 5) {
                return true;
            }
            // After that, apply the wave filter
            return waves.includes(item.Wave);
        });
    
        this.setState({ wavesSelected: waves, filteredData });
    }

    exportData() {
        let exportData = this.state.filteredData.length > 0 ? this.state.filteredData : this.state.rowData;
        this.props.exportCsvForVUF(exportData);
    }

    render() {
        return (
            <div className="grid-x">
                <div className="medium-12 popHeader vufHeader">{'Download Vendor Upload Files'}</div>
                <div className="medium-6 vufMultiSelect">
                    <div className="dropDownHeader">{'Select a wave'}</div>
                    <MultiSelect
                        className="border-with-DD dropDownContent multiSelectHeight multiSelectLabelPadding"
                        model='yourFile.RequestId'
                        id='RequestId'
                        value={this.state.wavesSelected}
                        onChange={value => this.handleWaveChange(value)}
                        options={this.state.wave}
                        display="chip"
                    />
                </div>
                <div className="medium-6 vufDownloadBtn">
                    <div className="float-right"><Button
                        content={this.props.content}
                        onClick={this.exportData.bind(this)}
                        color /></div>

                </div>
            </div>
        )
    }
}